import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {
    SimplePresentation,
    SimplePresentationRunner
} from "../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../HTH";
import {DropInPresentation} from "../presentations/avalanche/DropInPresentation";
import {FillUpPresentation} from "../presentations/avalanche/FillUpPresentation";
import {HTHEnhancerUnlockedPresentation} from "../presentations/HTHEnhancerUnlockedPresentation";

export class HTHNormalResultPresentation implements FlowStatePresentation {

    constructor() {
    }

    public start(flowStateController: FlowStateController) {
        const presentations: SimplePresentation[] = [];
        if (!HTH.model.isCurrentAvalanche) {
            presentations.push(new DropInPresentation());
        } else if (HTH.model.isCurrentAvalanche) {
            presentations.push(new HTHEnhancerUnlockedPresentation());
            presentations.push(new FillUpPresentation());
        }
        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback));
    }
}